const recipes = [
  {
    id: 1,
    image: "/static/media/classic_carbonara_spaghetti.png",
    title: "Classic Spaghetti Carbonara",
    ingredients: [
      { name: "spaghetti", quantity: "200g" },
      { name: "eggs", quantity: "2 pcs" },
      { name: "bacon", quantity: "100g" },
      { name: "parmesan cheese", quantity: "50g" },
      { name: "black pepper", quantity: "to taste" },
      { name: "olive oil", quantity: "1 tbsp" },
      { name: "garlic", quantity: "2 cloves" },
    ],
    description:
      "A classic Italian pasta dish made with spaghetti, eggs, bacon, parmesan cheese, and black pepper. It's creamy, savory, and satisfying.",
    instructions: [
      "Cook spaghetti according to package instructions.",
      "In a separate pan, cook bacon until crispy.",
      "In a bowl, whisk together eggs, parmesan cheese, and black pepper.",
      "Once spaghetti is cooked, drain and add to the pan with bacon.",
      "Quickly pour egg mixture over hot spaghetti and toss until eggs are cooked and coat the spaghetti.",
      "Serve hot with additional parmesan cheese and black pepper.",
    ],
    utensils: ["Pan", "Bowl", "Pot"],
    calories: 450,
    difficulty: "hard",
    duration: 30,
    cost: 10,
    favorite: false,
    country: "Italy",
    origin:
      "Spaghetti carbonara is a traditional Italian pasta dish believed to have originated in Rome. It was popularized in the mid-20th century and has since become a classic favorite worldwide.",
  },
  {
    id: 3,
    image: "/static/media/caesar_salad.png",
    title: "Grilled Chicken Caesar Salad",
    ingredients: [
      { name: "chicken breasts", quantity: "2 pcs" },
      { name: "romaine lettuce", quantity: "1 head" },
      { name: "parmesan cheese", quantity: "50g" },
      { name: "croutons", quantity: "1 cup" },
      { name: "Caesar dressing", quantity: "1/4 cup" },
      { name: "olive oil", quantity: "2 tbsp" },
      { name: "lemon", quantity: "1 pcs" },
      { name: "garlic", quantity: "2 cloves" },
    ],
    description:
      "A refreshing salad featuring grilled chicken, crisp romaine lettuce, shaved parmesan cheese, and crunchy croutons, all tossed in a tangy Caesar dressing.",
    instructions: [
      "Season chicken breasts with salt, pepper, minced garlic, and olive oil.",
      "Grill chicken until cooked through.",
      "In a large bowl, toss chopped romaine lettuce with Caesar dressing.",
      "Top the salad with grilled chicken, shaved parmesan cheese, and croutons.",
      "Squeeze fresh lemon juice over the salad.",
      "Serve immediately.",
    ],
    utensils: ["Grill", "Bowl"],
    calories: 320,
    difficulty: "hard",
    duration: 35,
    cost: 12,
    favorite: true,
    country: "Italy",
    origin:
      "Pizza has its origins in Naples, Italy, where it was a simple and affordable food for the working class. It has since evolved into a popular dish enjoyed worldwide in countless variations.",
  },
  {
    id: 4,
    image: "/static/media/homemade_pizza.png",
    title: "Homemade Pizza",
    ingredients: [
      { name: "pizza dough", quantity: "1 ball" },
      { name: "tomato sauce", quantity: "1/2 cup" },
      { name: "mozzarella cheese", quantity: "200g" },
      { name: "pepperoni", quantity: "10 slices" },
      { name: "bell peppers", quantity: "1 pc" },
      { name: "onion", quantity: "1 pcs" },
      { name: "mushrooms", quantity: "5 pcs" },
      { name: "olive oil", quantity: "1 tbsp" },
      { name: "garlic", quantity: "2 cloves" },
      { name: "oregano", quantity: "1 tsp" },
      { name: "basil", quantity: "1 tsp" },
    ],
    description:
      "Create your own pizza masterpiece with this homemade pizza recipe. Top a crispy crust with tomato sauce, melted mozzarella cheese, and your favorite toppings for a delicious meal.",
    instructions: [
      "Preheat oven to 450°F (230°C).",
      "Roll out pizza dough on a baking sheet.",
      "Spread tomato sauce over the dough, leaving a border around the edges.",
      "Sprinkle shredded mozzarella cheese evenly over the sauce.",
      "Add desired toppings such as pepperoni, sliced bell peppers, onions, and mushrooms.",
      "Drizzle olive oil over the pizza and sprinkle minced garlic, oregano, and basil.",
      "Bake in the preheated oven for 12-15 minutes or until the crust is golden brown and the cheese is bubbly.",
      "Slice and serve hot.",
    ],
    utensils: ["Oven", "Baking sheet"],
    calories: 420,
    difficulty: "easy",
    duration: 40,
    cost: 15,
    favorite: false,
    country: "Italy",
    origin:
      "Pizza has its origins in Naples, Italy, where it was a simple and affordable food for the working class. It has since evolved into a popular dish enjoyed worldwide in countless variations.",
  },
  {
    id: 5,
    image: "/static/media/chicken_noodle_soup.png",
    title: "Chicken Noodle Soup",
    ingredients: [
      { name: "chicken broth", quantity: "4 cups" },
      { name: "chicken breasts", quantity: "2 pcs" },
      { name: "carrots", quantity: "2 pcs" },
      { name: "celery", quantity: "2 stalks" },
      { name: "onion", quantity: "1 pc" },
      { name: "garlic", quantity: "3 cloves" },
      { name: "egg noodles", quantity: "1 cup" },
      { name: "bay leaf", quantity: "1 pc" },
      { name: "thyme", quantity: "1 tsp" },
      { name: "parsley", quantity: "2 tbsp" },
    ],
    description:
      "Warm up with a comforting bowl of chicken noodle soup. This hearty soup is loaded with tender chicken, egg noodles, and flavorful vegetables in a savory broth.",
    instructions: [
      "In a large pot, bring chicken broth to a boil.",
      "Add chopped carrots, celery, onion, minced garlic, bay leaf, thyme, and parsley to the pot.",
      "Reduce heat and simmer for 10 minutes.",
      "Add chicken breasts to the pot and simmer for an additional 15-20 minutes or until chicken is cooked through.",
      "Remove chicken breasts from the pot and shred with two forks.",
      "Return shredded chicken to the pot.",
      "Add egg noodles to the pot and cook until tender.",
      "Season with salt and black pepper to taste.",
      "Serve hot.",
    ],
    utensils: ["Pot", "Cutting board", "Knife"],
    calories: 280,
    difficulty: "hard",
    duration: 45,
    cost: 10,
    favorite: true,
    country: "United States",
    origin:
      "Chicken noodle soup has been a staple comfort food in American households for generations. It gained popularity during the Great Depression as an affordable and nourishing meal.",
  },
  {
    id: 6,
    image: "/static/media/chocolate_cookies.png",
    title: "Chocolate Chip Cookies",
    ingredients: [
      { name: "all-purpose flour", quantity: "2 cups" },
      { name: "baking soda", quantity: "1 tsp" },
      { name: "salt", quantity: "1/2 tsp" },
      { name: "unsalted butter", quantity: "1 cup" },
      { name: "granulated sugar", quantity: "3/4 cup" },
      { name: "brown sugar", quantity: "3/4 cup" },
      { name: "vanilla extract", quantity: "1 tsp" },
      { name: "eggs", quantity: "2 pcs" },
      { name: "chocolate chips", quantity: "2 cups" },
    ],
    description:
      "Indulge your sweet tooth with these classic chocolate chip cookies. Soft and chewy on the inside, crispy on the outside, and packed with rich chocolate chips.",
    instructions: [
      "Preheat oven to 375°F (190°C).",
      "In a mixing bowl, whisk together flour, baking soda, and salt.",
      "In a separate bowl, cream together softened butter, granulated sugar, and brown sugar until light and fluffy.",
      "Beat in vanilla extract and eggs, one at a time.",
      "Gradually add dry ingredients to the wet ingredients and mix until combined.",
      "Stir in chocolate chips.",
      "Drop spoonfuls of dough onto a baking sheet lined with parchment paper.",
      "Bake in the preheated oven for 8-10 minutes or until edges are golden brown.",
      "Let cool on the baking sheet for a few minutes before transferring to a wire rack to cool completely.",
    ],
    utensils: ["Oven", "Mixing bowl", "Baking sheet"],
    calories: 150,
    difficulty: "easy",
    duration: 20,
    cost: 7,
    favorite: true,
    country: "United States",
    origin:
      "Chocolate chip cookies are a beloved American treat that originated in the 1930s. They have since become one of the most popular types of cookies worldwide.",
  },
  {
    id: 7,
    image: "/static/media/caprese_salad.png",
    title: "Caprese Salad",
    ingredients: [
      { name: "tomatoes", quantity: "2 pcs" },
      { name: "fresh mozzarella cheese", quantity: "200g" },
      { name: "fresh basil leaves", quantity: "1 bunch" },
      { name: "balsamic glaze", quantity: "2 tbsp" },
      { name: "extra-virgin olive oil", quantity: "2 tbsp" },
      { name: "salt", quantity: "to taste" },
      { name: "black pepper", quantity: "to taste" },
    ],
    description:
      "Enjoy the fresh flavors of summer with a simple and elegant Caprese salad. Layers of ripe tomatoes, creamy mozzarella cheese, and fragrant basil, drizzled with balsamic glaze and olive oil.",
    instructions: [
      "Slice tomatoes and fresh mozzarella cheese into thin slices.",
      "Arrange tomato slices and mozzarella slices on a serving platter, alternating and overlapping them.",
      "Tuck fresh basil leaves between the tomato and mozzarella slices.",
      "Drizzle with balsamic glaze and extra-virgin olive oil.",
      "Season with salt and black pepper to taste.",
      "Serve immediately.",
    ],
    utensils: ["Knife", "Cutting board"],
    calories: 180,
    difficulty: "easy",
    duration: 15,
    cost: 5,
    favorite: false,
    country: "Italy",
    origin:
      "Caprese salad, named after the island of Capri in Italy, is a simple yet elegant dish that showcases the flavors of fresh tomatoes, mozzarella cheese, and basil. It is a popular antipasto in Italian cuisine.",
  },
  {
    id: 8,
    image: "/static/media/carbonara_spaghetti.png",
    title: "Spaghetti Carbonara",
    ingredients: [
      { name: "spaghetti pasta", quantity: "200g" },
      { name: "bacon or pancetta", quantity: "100g" },
      { name: "eggs", quantity: "2 pcs" },
      { name: "parmesan cheese", quantity: "50g" },
      { name: "garlic", quantity: "2 cloves" },
      { name: "black pepper", quantity: "to taste" },
      { name: "salt", quantity: "to taste" },
    ],
    description:
      "A delicious and indulgent pasta dish featuring spaghetti coated in a creamy sauce made from eggs, parmesan cheese, and crispy bacon. It's quick, easy, and oh-so-satisfying.",
    instructions: [
      "Cook spaghetti pasta according to package instructions until al dente.",
      "In a skillet, cook chopped bacon or pancetta until crispy.",
      "While the pasta and bacon are cooking, whisk together eggs, grated parmesan cheese, minced garlic, black pepper, and a pinch of salt in a bowl.",
      "Once the pasta is cooked, drain it, reserving some of the pasta water.",
      "Immediately transfer the hot pasta to the skillet with the cooked bacon, tossing to combine.",
      "Remove the skillet from heat and quickly pour the egg and cheese mixture over the hot pasta, stirring constantly to coat the pasta in the creamy sauce. The residual heat from the pasta will cook the eggs and melt the cheese. Add a splash of reserved pasta water if needed to loosen the sauce.",
      "Serve immediately, garnished with additional grated parmesan cheese and black pepper.",
    ],
    utensils: ["Skillet", "Pot", "Bowl"],
    calories: 400,
    difficulty: "hard",
    duration: 25,
    cost: 9,
    favorite: false,
    country: "Italy",
    origin:
      "Spaghetti carbonara is a classic Italian pasta dish believed to have originated in Rome. It is made with simple ingredients like eggs, cheese, and bacon or pancetta. The name 'carbonara' is derived from 'carbonaro', which means 'charcoal burner' in Italian, suggesting that the dish was popular among charcoal workers in the region.",
  },
  {
    id: 9,
    image: "/static/media/mushroom_risotto.png",
    title: "Mushroom Risotto",
    ingredients: [
      { name: "arborio rice", quantity: "1 cup" },
      { name: "chicken or vegetable broth", quantity: "4 cups" },
      { name: "mushrooms", quantity: "200g" },
      { name: "shallots", quantity: "2 pcs" },
      { name: "garlic", quantity: "2 cloves" },
      { name: "white wine", quantity: "1/2 cup" },
      { name: "butter", quantity: "2 tbsp" },
      { name: "parmesan cheese", quantity: "50g" },
      { name: "olive oil", quantity: "2 tbsp" },
      { name: "salt", quantity: "to taste" },
      { name: "black pepper", quantity: "to taste" },
    ],
    description:
      "Savor the rich and earthy flavors of mushroom risotto. Creamy Arborio rice cooked to perfection with sautéed mushrooms, shallots, and parmesan cheese.",
    instructions: [
      "In a saucepan, heat chicken or vegetable broth and keep warm over low heat.",
      "In a separate pan, sauté chopped shallots and minced garlic in olive oil until translucent.",
      "Add arborio rice to the pan and toast until lightly golden.",
      "Deglaze the pan with white wine and cook until the wine is absorbed.",
      "Begin adding warm broth to the rice, one ladleful at a time, stirring frequently and allowing the broth to be absorbed before adding more.",
      "Continue this process until the rice is creamy and cooked al dente, about 20-25 minutes.",
      "In another pan, sauté sliced mushrooms in butter until golden brown.",
      "Stir cooked mushrooms into the risotto along with grated parmesan cheese.",
      "Season with salt and black pepper to taste.",
      "Serve hot.",
    ],
    utensils: ["Saucepan", "Pan", "Bowl"],
    calories: 380,
    difficulty: "hard",
    duration: 35,
    cost: 11,
    favorite: true,
    country: "Italy",
    origin:
      "Risotto is a traditional Italian dish made with Arborio rice, which is a short-grain rice known for its high starch content. Mushroom risotto is a popular variation that highlights the earthy flavor of mushrooms. It is often served as a main course or as a side dish alongside grilled meats or seafood.",
  },
  {
    id: 10,
    image: "/static/media/banana_bread.png",
    title: "Banana Bread",
    ingredients: [
      { name: "ripe bananas", quantity: "3 pcs" },
      { name: "all-purpose flour", quantity: "2 cups" },
      { name: "baking soda", quantity: "1 tsp" },
      { name: "salt", quantity: "1/2 tsp" },
      { name: "unsalted butter", quantity: "1/2 cup" },
      { name: "granulated sugar", quantity: "3/4 cup" },
      { name: "eggs", quantity: "2 pcs" },
      { name: "vanilla extract", quantity: "1 tsp" },
      { name: "walnuts (optional)", quantity: "1/2 cup" },
    ],
    description:
      "Turn overripe bananas into a moist and delicious loaf of banana bread. This classic recipe is simple to make and perfect for breakfast or as a snack.",
    instructions: [
      "Preheat oven to 350°F (175°C).",
      "Grease a 9x5-inch loaf pan.",
      "In a mixing bowl, mash ripe bananas with a fork until smooth.",
      "In a separate bowl, whisk together flour, baking soda, and salt.",
      "In another bowl, cream together softened butter and granulated sugar until light and fluffy.",
      "Beat in vanilla extract and eggs, one at a time.",
      "Gradually add dry ingredients to the wet ingredients and mix until combined.",
      "Stir in chopped walnuts if desired.",
      "Pour batter into the prepared loaf pan.",
      "Bake in the preheated oven for 60-70 minutes or until a toothpick inserted into the center comes out clean.",
      "Let cool in the pan for 10 minutes before transferring to a wire rack to cool completely.",
    ],
    utensils: ["Oven", "Mixing bowl", "Loaf pan"],
    calories: 220,
    difficulty: "easy",
    duration: 70,
    cost: 6,
    favorite: true,
    country: "United States",
    origin:
      "Banana bread became popular in the United States during the Great Depression as a way to use up overripe bananas that would otherwise go to waste. It is now a beloved baked good enjoyed around the world.",
  },
  {
    id: 27,
    image: "/static/media/jollof_rice.jpg",
    title: "Jollof Rice",
    ingredients: [
      { name: "rice", quantity: "2 cups" },
      { name: "tomatoes", quantity: "4 pcs" },
      { name: "onion", quantity: "1 pc" },
      { name: "bell pepper", quantity: "1 pc" },
      { name: "scotch bonnet pepper", quantity: "1 pc" },
      { name: "garlic", quantity: "3 cloves" },
      { name: "ginger", quantity: "1 inch piece" },
      { name: "tomato paste", quantity: "3 tbsp" },
      { name: "vegetable oil", quantity: "3 tbsp" },
      { name: "chicken or beef broth", quantity: "2 cups" },
      { name: "thyme", quantity: "1 tsp" },
      { name: "curry powder", quantity: "1 tsp" },
      { name: "smoked paprika", quantity: "1 tsp" },
      { name: "bay leaf", quantity: "1 pc" },
      { name: "salt", quantity: "to taste" },
      { name: "black pepper", quantity: "to taste" }
    ],
    description: "Jollof Rice is a popular West African dish made with rice, tomatoes, and a variety of spices. It's known for its vibrant red color and rich, savory flavor.",
    instructions: [
      "Blend tomatoes, onion, bell pepper, scotch bonnet pepper, garlic, and ginger until smooth to make a tomato sauce.",
      "Heat vegetable oil in a large pot over medium heat.",
      "Add tomato paste to the pot and cook for a few minutes until fragrant.",
      "Pour in the blended tomato sauce and cook until it thickens.",
      "Stir in chicken or beef broth, thyme, curry powder, smoked paprika, bay leaf, salt, and black pepper.",
      "Add rice to the pot and stir to combine with the sauce.",
      "Cover the pot and simmer over low heat until the rice is cooked and the liquid is absorbed, about 20-25 minutes.",
      "Fluff the rice with a fork before serving.",
      "Enjoy hot as a main dish or side dish."
    ],
    utensils: ["Pot", "Blender"],
    calories: 320,
    difficulty: "medium",
    duration: 45,
    cost: 8,
    favorite: true,
    country: "West Africa",
    origin: "Jollof Rice is a beloved dish across West Africa, with each region adding its own twist to the recipe. It's often served at celebrations and gatherings, and is considered a staple dish in many West African households."
  }
  ,{
    id: 12,
    image: "/static/media/fufu_egusi_soup.jpg",
    title: "Fufu and Egusi Soup",
    ingredients: [
      { name: "egusi seeds", quantity: "1 cup" },
      { name: "spinach", quantity: "2 cups" },
      { name: "tomatoes", quantity: "3 pcs" },
      { name: "onion", quantity: "1 pc" },
      { name: "scotch bonnet pepper", quantity: "1 pc" },
      { name: "garlic", quantity: "3 cloves" },
      { name: "ginger", quantity: "1 inch piece" },
      { name: "beef or goat meat", quantity: "500g" },
      { name: "palm oil", quantity: "1/4 cup" },
      { name: "stockfish or dried fish", quantity: "200g" },
      { name: "crayfish", quantity: "1/4 cup" },
      { name: "seasoning cubes", quantity: "2 pcs" },
      { name: "salt", quantity: "to taste" },
      { name: "black pepper", quantity: "to taste" }
    ],
    description: "Fufu and Egusi Soup is a traditional African dish made with ground melon seeds, spinach, and a variety of meats. It's hearty, flavorful, and perfect for sharing with family and friends.",
    instructions: [
      "Blend tomatoes, onion, scotch bonnet pepper, garlic, and ginger until smooth to make a tomato sauce.",
      "Heat palm oil in a large pot over medium heat.",
      "Add the blended tomato sauce to the pot and cook until it thickens.",
      "Season beef or goat meat with salt and black pepper, and add to the pot along with stockfish or dried fish.",
      "Simmer until the meat is cooked through and tender.",
      "In a separate pot, boil water and add egusi seeds, stirring continuously to prevent lumps.",
      "Once the egusi seeds are cooked and thickened, add to the pot of meat and tomato sauce.",
      "Stir in spinach, crayfish, seasoning cubes, salt, and black pepper.",
      "Simmer for a few minutes until the spinach wilts and the flavors meld together.",
      "Serve hot with fufu or pounded yam."
    ],
    utensils: ["Pot", "Blender"],
    calories: 380,
    difficulty: "medium",
    duration: 60,
    cost: 12,
    favorite: false,
    country: "West Africa",
    origin: "Fufu and Egusi Soup is a traditional dish enjoyed in many West African countries, including Nigeria, Ghana, and Cameroon. It's often served at special occasions and celebrations, and is cherished for its rich flavors and cultural significance."
  }
  
  ,
  {
    id: 13,
    image: "/static/media/pho.jpg",
    title: "Pho",
    ingredients: [
      { name: "beef bones", quantity: "2 kg" },
      { name: "onion", quantity: "1 pc" },
      { name: "ginger", quantity: "1 pc" },
      { name: "star anise", quantity: "3 pcs" },
      { name: "cinnamon stick", quantity: "1 pc" },
      { name: "cloves", quantity: "3 pcs" },
      { name: "beef sirloin", quantity: "400g" },
      { name: "rice noodles", quantity: "400g" },
      { name: "bean sprouts", quantity: "1 cup" },
      { name: "Thai basil leaves", quantity: "1 cup" },
      { name: "lime", quantity: "2 pcs" },
      { name: "jalapeno peppers", quantity: "2 pcs" },
      { name: "hoisin sauce", quantity: "1/4 cup" },
      { name: "sriracha sauce", quantity: "1/4 cup" },
    ],
    description:
      "Pho is a traditional Vietnamese noodle soup consisting of broth, rice noodles, herbs, and meat (usually beef or chicken). It is often served with bean sprouts, lime wedges, Thai basil, and chili peppers on the side, allowing diners to customize their soup to their liking.",
    instructions: [
      "Place beef bones in a large pot and cover with water.",
      "Add chopped onion, ginger, star anise, cinnamon stick, and cloves to the pot.",
      "Bring to a boil, then reduce heat and simmer for several hours to extract flavor from the bones and spices.",
      "Strain the broth and return it to the pot.",
      "Slice beef sirloin thinly and cook in the hot broth until just cooked through.",
      "Soak rice noodles in hot water until softened, then drain and divide among serving bowls.",
      "Top noodles with cooked beef slices and bean sprouts.",
      "Ladle hot broth over the noodles and beef.",
      "Serve with Thai basil leaves, lime wedges, sliced jalapeno peppers, hoisin sauce, and sriracha sauce on the side.",
      "Enjoy!",
    ],
    utensils: ["Large pot", "Strainer"],
    calories: 400,
    difficulty: "hard",
    duration: 240,
    cost: 15,
    favorite: true,
    country: "Vietnam",
    origin:
      "Pho originated in northern Vietnam in the early 20th century and has since become one of Vietnam's most popular dishes. It was influenced by both Chinese and French culinary traditions and is now enjoyed worldwide as a comforting and flavorful soup.",
  },
  {
    id: 14,
    image: "/static/media/pad_thai.jpg",
    title: "Pad Thai",
    ingredients: [
      { name: "rice noodles", quantity: "200g" },
      { name: "shrimp", quantity: "200g" },
      { name: "firm tofu", quantity: "200g" },
      { name: "bean sprouts", quantity: "1 cup" },
      { name: "garlic", quantity: "3 cloves" },
      { name: "shallots", quantity: "2 pcs" },
      { name: "eggs", quantity: "2 pcs" },
      { name: "peanuts", quantity: "1/4 cup" },
      { name: "green onions", quantity: "1/4 cup" },
      { name: "lime", quantity: "1 pc" },
      { name: "tamarind paste", quantity: "2 tbsp" },
      { name: "fish sauce", quantity: "2 tbsp" },
      { name: "palm sugar", quantity: "2 tbsp" },
      { name: "vegetable oil", quantity: "3 tbsp" },
      { name: "chili flakes", quantity: "to taste" },
    ],
    description:
      "Pad Thai is a popular Thai street food dish made with stir-fried rice noodles, shrimp, tofu, eggs, and bean sprouts, seasoned with a sweet and tangy sauce made from tamarind paste, fish sauce, and palm sugar. It is typically garnished with crushed peanuts, green onions, and lime wedges.",
    instructions: [
      "Soak rice noodles in warm water until softened, then drain and set aside.",
      "Heat vegetable oil in a wok or large skillet over medium-high heat.",
      "Add minced garlic and shallots to the wok and cook until fragrant.",
      "Add shrimp and tofu to the wok and cook until shrimp are pink and tofu is lightly browned.",
      "Push ingredients to one side of the wok and crack eggs into the empty space.",
      "Scramble eggs until cooked, then mix with other ingredients in the wok.",
      "Add softened rice noodles to the wok along with tamarind paste, fish sauce, and palm sugar.",
      "Stir-fry everything together until well combined and heated through.",
      "Add bean sprouts and chopped green onions to the wok and toss to combine.",
      "Transfer pad Thai to serving plates and garnish with crushed peanuts and chili flakes.",
      "Serve with lime wedges on the side.",
    ],
    utensils: ["Wok", "Skillet"],
    calories: 400,
    difficulty: "hard",
    duration: 30,
    cost: 15,
    favorite: true,
    country: "Thailand",
    origin:
      "Pad Thai is a relatively modern dish, believed to have been created in the 20th century as part of a campaign to promote Thai nationalism. It became popular in Thailand during the Second World War and has since become a staple of Thai cuisine.",
  },
  {
    id: 15,
    image: "/static/media/lasagna.jpg",
    title: "Lasagna",
    ingredients: [
      { name: "lasagna noodles", quantity: "12 sheets" },
      { name: "ground beef", quantity: "500g" },
      { name: "onion", quantity: "1 pc" },
      { name: "garlic", quantity: "3 cloves" },
      { name: "tomato sauce", quantity: "800g" },
      { name: "ricotta cheese", quantity: "500g" },
      { name: "mozzarella cheese", quantity: "250g" },
      { name: "parmesan cheese", quantity: "100g" },
      { name: "fresh basil", quantity: "1/4 cup" },
      { name: "dried oregano", quantity: "1 tbsp" },
      { name: "olive oil", quantity: "2 tbsp" },
      { name: "salt", quantity: "to taste" },
      { name: "black pepper", quantity: "to taste" },
    ],
    description:
      "Lasagna is a classic Italian pasta dish made with layers of lasagna noodles, tomato sauce, ground meat (usually beef or pork), ricotta cheese, mozzarella cheese, and parmesan cheese. It is typically baked until bubbly and golden brown, with the cheese melting into the sauce and noodles for a comforting and hearty meal.",
    instructions: [
      "Preheat oven to 375°F (190°C).",
      "Cook lasagna noodles according to package instructions until al dente, then drain and set aside.",
      "Heat olive oil in a large skillet over medium heat.",
      "Add minced garlic and chopped onion to the skillet and cook until softened.",
      "Add ground beef to the skillet and cook until browned, breaking it up with a spoon.",
      "Stir in tomato sauce, fresh basil, dried oregano, salt, and black pepper.",
      "In a separate bowl, mix together ricotta cheese, grated mozzarella cheese, and grated parmesan cheese.",
      "Spread a thin layer of meat sauce in the bottom of a baking dish.",
      "Arrange a layer of cooked lasagna noodles on top of the sauce.",
      "Spread a layer of the cheese mixture over the noodles.",
      "Repeat layers until all ingredients are used, ending with a layer of meat sauce on top.",
      "Cover the baking dish with foil and bake in the preheated oven for 25 minutes.",
      "Remove foil and bake for an additional 10 minutes or until cheese is bubbly and golden brown.",
      "Let lasagna cool for a few minutes before serving.",
    ],
    utensils: ["Skillet", "Baking dish"],
    calories: 450,
    difficulty: "hard",
    duration: 60,
    cost: 20,
    favorite: true,
    country: "Italy",
    origin:
      "Lasagna is believed to have originated in ancient Greece, where layered dishes similar to lasagna were made using pasta and various ingredients. However, modern lasagna as we know it today is attributed to Italy, where it became popular during the Middle Ages.",
  },
  {
    id: 16,
    image: "/static/media/sushi.jpg",
    title: "Sushi",
    ingredients: [
      { name: "sushi rice", quantity: "2 cups" },
      { name: "nori seaweed sheets", quantity: "5 pcs" },
      { name: "sashimi-grade fish (tuna, salmon, etc.)", quantity: "300g" },
      { name: "avocado", quantity: "1 pc" },
      { name: "cucumber", quantity: "1 pc" },
      { name: "sesame seeds", quantity: "2 tbsp" },
      { name: "rice vinegar", quantity: "1/4 cup" },
      { name: "sugar", quantity: "2 tbsp" },
      { name: "salt", quantity: "1 tsp" },
      { name: "soy sauce", quantity: "for dipping" },
      { name: "wasabi", quantity: "for dipping" },
      { name: "pickled ginger", quantity: "for serving" },
    ],
    description:
      "Sushi is a Japanese dish consisting of vinegared rice topped or rolled with various ingredients, such as seafood (sashimi-grade fish), vegetables, and nori seaweed. It is often served with soy sauce, wasabi, and pickled ginger.",
    instructions: [
      "Rinse sushi rice in cold water until the water runs clear, then drain well.",
      "In a saucepan, combine rice vinegar, sugar, and salt, and heat until sugar and salt are dissolved.",
      "Cook sushi rice according to package instructions, then transfer to a large bowl and fold in the vinegar mixture.",
      "Cover rice with a damp cloth and let cool to room temperature.",
      "Slice sashimi-grade fish, avocado, and cucumber into thin strips.",
      "Lay a sheet of nori seaweed on a bamboo sushi mat, shiny side down.",
      "Spread a thin layer of sushi rice over the nori seaweed, leaving a 1-inch border at the top edge.",
      "Arrange strips of fish, avocado, and cucumber along the bottom edge of the rice.",
      "Roll the sushi tightly using the bamboo mat, moistening the top edge of the nori seaweed with water to seal the roll.",
      "Slice the sushi roll into bite-sized pieces using a sharp knife.",
      "Repeat with remaining ingredients.",
      "Serve sushi with soy sauce, wasabi, and pickled ginger.",
    ],
    utensils: ["Saucepan", "Sushi mat"],
    calories: 350,
    difficulty: "hard",
    duration: 45,
    cost: 25,
    favorite: true,
    country: "Japan",
    origin:
      "Sushi has been a staple of Japanese cuisine for centuries, with its origins dating back to the 8th century. Originally, sushi was made by fermenting fish and rice together, but over time, it evolved into the fresh and flavorful dish we know today.",
  },
  {
    id: 17,
    image: "/static/media/paella.jpg",
    title: "Paella",
    ingredients: [
      { name: "short-grain rice", quantity: "2 cups" },
      { name: "chicken thighs", quantity: "4 pcs" },
      { name: "chorizo sausage", quantity: "200g" },
      { name: "shrimp", quantity: "200g" },
      { name: "mussels", quantity: "200g" },
      { name: "onion", quantity: "1 pc" },
      { name: "garlic", quantity: "4 cloves" },
      { name: "bell peppers", quantity: "2 pcs" },
      { name: "tomatoes", quantity: "2 pcs" },
      { name: "saffron threads", quantity: "1/2 tsp" },
      { name: "paprika", quantity: "1 tsp" },
      { name: "olive oil", quantity: "1/4 cup" },
      { name: "chicken broth", quantity: "4 cups" },
      { name: "lemon", quantity: "1 pc" },
      { name: "fresh parsley", quantity: "1/4 cup" },
      { name: "salt", quantity: "to taste" },
      { name: "black pepper", quantity: "to taste" },
    ],
    description:
      "Paella is a Spanish rice dish originally from the Valencia region, traditionally cooked in a wide, shallow pan over an open flame. It typically contains a variety of ingredients such as chicken, chorizo sausage, seafood (shrimp, mussels), and vegetables (bell peppers, tomatoes), seasoned with saffron and paprika.",
    instructions: [
      "Heat olive oil in a paella pan or large skillet over medium-high heat.",
      "Add chopped onion, minced garlic, and diced bell peppers to the pan and cook until softened.",
      "Add chicken thighs and chorizo sausage to the pan and cook until browned.",
      "Stir in chopped tomatoes, short-grain rice, saffron threads, and paprika.",
      "Pour in chicken broth and bring to a boil, then reduce heat and simmer until rice is cooked and liquid is absorbed.",
      "Arrange shrimp and mussels on top of the rice mixture, cover, and cook until seafood is cooked through and shells have opened.",
      "Remove from heat and let paella rest for a few minutes before serving.",
      "Garnish with lemon wedges and chopped fresh parsley before serving.",
    ],
    utensils: ["Paella pan", "Skillet"],
    calories: 500,
    difficulty: "hard",
    duration: 60,
    cost: 30,
    favorite: true,
    country: "Spain",
    origin:
      "Paella originated in the Valencia region of Spain, where it was traditionally cooked by farmers and farm laborers over an open fire in the fields. It was made with whatever ingredients were readily available, often including rice, beans, and rabbit or chicken. Over time, it evolved into the iconic dish we know today, with seafood becoming a popular addition.",
  },
  {
    id: 29,
    image: "/static/media/mapo_tofu.jpg",
    title: "Mapo Tofu",
    ingredients: [
      { name: "firm tofu", quantity: "1 block" },
      { name: "ground pork", quantity: "100g" },
      { name: "green onions", quantity: "2 stalks" },
      { name: "ginger", quantity: "1 inch piece" },
      { name: "garlic", quantity: "3 cloves" },
      { name: "dried red chilies", quantity: "6 pcs" },
      { name: "Sichuan peppercorns", quantity: "1 tsp" },
      { name: "soy sauce", quantity: "2 tbsp" },
      { name: "doubanjiang (chili bean paste)", quantity: "2 tbsp" },
      { name: "chicken broth", quantity: "1 cup" },
      { name: "cornstarch", quantity: "1 tbsp" },
      { name: "sesame oil", quantity: "1 tsp" },
      { name: "vegetable oil", quantity: "2 tbsp" },
      { name: "salt", quantity: "to taste" },
      { name: "black pepper", quantity: "to taste" },
    ],
    description:
      "Mapo Tofu is a classic Chinese dish made with soft tofu and minced pork cooked in a spicy, savory sauce. It's known for its numbing heat and complex flavors, making it a favorite in Sichuan cuisine.",
    instructions: [
      "Cut tofu into cubes and set aside.",
      "Heat vegetable oil in a wok or skillet over high heat.",
      "Add minced ginger, minced garlic, dried red chilies, and Sichuan peppercorns to the hot oil, and stir-fry until fragrant.",
      "Add ground pork to the wok and stir-fry until browned.",
      "Stir in doubanjiang (chili bean paste) and soy sauce, and cook for a few minutes.",
      "Add chicken broth to the wok and bring to a simmer.",
      "Carefully add tofu cubes to the wok and simmer gently until heated through.",
      "Mix cornstarch with water to make a slurry, and stir into the sauce to thicken.",
      "Drizzle sesame oil over the top before serving.",
      "Garnish with sliced green onions and serve hot with steamed rice.",
    ],
    utensils: ["Wok", "Skillet"],
    calories: 280,
    difficulty: "medium",
    duration: 40,
    cost: 10,
    favorite: false,
    country: "China",
    origin:
      "Mapo Tofu originated in the Sichuan Province of China and is named after its creator, a woman named Chen Mapo. It's a popular dish in Sichuan cuisine known for its bold flavors, including the numbing heat of Sichuan peppercorns and the spicy kick of dried red chilies.",
  },
  {
    id: 19,
    image: "/static/media/kung_pao_chicken.jpg",
    title: "Kung Pao Chicken",
    ingredients: [
      { name: "chicken breast", quantity: "2 pcs" },
      { name: "peanuts", quantity: "1/2 cup" },
      { name: "bell pepper", quantity: "1 pc" },
      { name: "dried red chilies", quantity: "6 pcs" },
      { name: "green onions", quantity: "2 stalks" },
      { name: "ginger", quantity: "1 inch piece" },
      { name: "garlic", quantity: "3 cloves" },
      { name: "soy sauce", quantity: "3 tbsp" },
      { name: "hoisin sauce", quantity: "2 tbsp" },
      { name: "rice vinegar", quantity: "1 tbsp" },
      { name: "cornstarch", quantity: "1 tbsp" },
      { name: "sesame oil", quantity: "1 tsp" },
      { name: "vegetable oil", quantity: "2 tbsp" },
      { name: "salt", quantity: "to taste" },
      { name: "black pepper", quantity: "to taste" },
    ],
    description:
      "Kung Pao Chicken is a classic Chinese stir-fry dish featuring tender chicken, peanuts, and vegetables in a spicy and savory sauce. It's quick and easy to make, perfect for a weeknight dinner.",
    instructions: [
      "Slice chicken breast into bite-sized pieces and marinate with soy sauce, rice vinegar, cornstarch, salt, and black pepper.",
      "Heat vegetable oil in a wok or skillet over high heat.",
      "Add dried red chilies, minced ginger, and minced garlic to the hot oil, and stir-fry until fragrant.",
      "Add marinated chicken to the wok and stir-fry until cooked through.",
      "Add diced bell pepper and peanuts to the wok, and continue stir-frying until bell pepper is tender-crisp.",
      "Stir in hoisin sauce and sesame oil, and toss to coat everything evenly.",
      "Garnish with sliced green onions before serving.",
      "Enjoy hot with steamed rice.",
    ],
    utensils: ["Wok", "Skillet"],
    calories: 320,
    difficulty: "medium",
    duration: 30,
    cost: 15,
    favorite: true,
    country: "China",
    origin:
      "Kung Pao Chicken is named after Ding Baozhen, a late Qing Dynasty official, and governor of Sichuan Province. It's a spicy stir-fry dish that originated in the Sichuan Province of China and has become popular worldwide for its bold flavors and addictive heat.",
  },
  {
    id: 20,
    image: "/static/media/ratatouille.jpg",
    title: "Ratatouille",
    ingredients: [
      { name: "eggplant", quantity: "1 pc" },
      { name: "zucchini", quantity: "1 pc" },
      { name: "yellow squash", quantity: "1 pc" },
      { name: "bell pepper", quantity: "1 pc" },
      { name: "onion", quantity: "1 pc" },
      { name: "garlic", quantity: "3 cloves" },
      { name: "tomatoes", quantity: "2 pcs" },
      { name: "olive oil", quantity: "3 tbsp" },
      { name: "thyme", quantity: "1 tsp" },
      { name: "bay leaf", quantity: "1 pc" },
      { name: "basil", quantity: "for garnish" },
      { name: "salt", quantity: "to taste" },
      { name: "black pepper", quantity: "to taste" },
    ],
    description:
      "Ratatouille is a traditional French vegetable stew made with eggplant, zucchini, bell pepper, onion, and tomatoes. It's bursting with flavor and makes a delicious side dish or vegetarian main course.",
    instructions: [
      "Preheat oven to 375°F (190°C).",
      "Slice eggplant, zucchini, yellow squash, bell pepper, and onion into thin rounds.",
      "Dice tomatoes and mince garlic.",
      "Drizzle olive oil in the bottom of a baking dish and spread minced garlic over the oil.",
      "Arrange sliced vegetables in overlapping layers in the baking dish, alternating colors.",
      "Drizzle olive oil over the top, then sprinkle with thyme, salt, and black pepper.",
      "Place a bay leaf on top of the vegetables.",
      "Cover the baking dish with aluminum foil and bake for 45-60 minutes, or until vegetables are tender.",
      "Remove bay leaf before serving, and garnish with fresh basil.",
      "Enjoy!",
    ],
    utensils: ["Baking dish"],
    calories: 180,
    difficulty: "easy",
    duration: 60,
    cost: 12,
    favorite: false,
    country: "France",
    origin:
      "Ratatouille originated in the Provence region of France and has been enjoyed for centuries as a simple and flavorful way to showcase seasonal vegetables. It's often served as a side dish, but can also be enjoyed on its own or with crusty bread.",
  },
  {
    id: 21,
    image: "/static/media/coq_au_vin.jpg",
    title: "Coq au Vin",
    ingredients: [
      { name: "chicken thighs", quantity: "4 pcs" },
      { name: "bacon", quantity: "100g" },
      { name: "pearl onions", quantity: "200g" },
      { name: "carrots", quantity: "2 pcs" },
      { name: "button mushrooms", quantity: "200g" },
      { name: "garlic", quantity: "3 cloves" },
      { name: "red wine", quantity: "1 bottle" },
      { name: "chicken broth", quantity: "2 cups" },
      { name: "all-purpose flour", quantity: "2 tbsp" },
      { name: "butter", quantity: "2 tbsp" },
      { name: "olive oil", quantity: "2 tbsp" },
      { name: "bay leaf", quantity: "2 pcs" },
      { name: "thyme", quantity: "1 tsp" },
      { name: "parsley", quantity: "for garnish" },
      { name: "salt", quantity: "to taste" },
      { name: "black pepper", quantity: "to taste" },
    ],
    description:
      "Coq au Vin is a classic French dish featuring chicken braised in red wine with mushrooms, onions, and bacon. It's hearty, flavorful, and perfect for a cozy dinner.",
    instructions: [
      "Season chicken thighs with salt and black pepper, then dust with flour.",
      "In a large skillet, heat olive oil and butter over medium heat.",
      "Brown chicken thighs on both sides, then remove from skillet and set aside.",
      "In the same skillet, add diced bacon and cook until crispy.",
      "Add pearl onions, sliced carrots, and minced garlic to the skillet, and cook until softened.",
      "Return chicken thighs to the skillet, along with button mushrooms, bay leaves, and thyme.",
      "Pour in red wine and chicken broth, ensuring chicken is mostly submerged.",
      "Bring to a simmer, then cover and cook over low heat for 1-2 hours, until chicken is tender and sauce has thickened.",
      "Serve hot, garnished with chopped parsley.",
      "Enjoy!",
    ],
    utensils: ["Skillet"],
    calories: 450,
    difficulty: "medium",
    duration: 120,
    cost: 25,
    favorite: true,
    country: "France",
    origin:
      "Coq au Vin dates back to medieval France, where it was originally made with old rooster meat that needed to be braised for a long time to become tender. Today, it's considered a classic French comfort food and is enjoyed around the world.",
  },
];

export default recipes;
